// Initialize the Swiper carousel on elements with the class 'custom-hero-carousel__carousel'
var swiper = new Swiper(".custom-hero-carousel__carousel", {
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
